import { ProfitLossModel, ProfitLossRequest } from "../../../infrastructure/model/ProfitLossModel";
import ProfitLossService from "../../../infrastructure/services/ProfitLossService";
import HttpUtils from "../../utils/HttpUtils";
import { BaseCommonApiUseCaseDeps } from "./CommonApiUseCase";

export const getProfitLossDataUseCase = async (
  deps: BaseCommonApiUseCaseDeps & {
    request: ProfitLossRequest;
  },
): Promise<ProfitLossModel | undefined> => {
  const { setLoading, showError, request } = deps;
  try {
    setLoading?.(true);
    let dataMapper: ProfitLossModel | undefined = undefined;
    const res = await ProfitLossService.getListOperatingCost(request);
    HttpUtils.handleResponse(res, {
      onDefaultError() {
        showError?.(res.message);
      },
      onSuccessWithData(res) {
        dataMapper = res.data;
      },
    });
    return dataMapper;
  } finally {
    setLoading?.(false);
  }
};
